import React, {useEffect, useState, useRef} from 'react';
import {dateToCalendar, showToast} from './app_common'
import {putApiUserPassword} from '../common/fetch_api/api_common.js';
import { Button, Modal } from 'react-bootstrap';
import {BsFillRocketTakeoffFill, BsCheckCircleFill} from "react-icons/bs";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { PageNation } from './component_common.js';
import { utcToLocalDate, convertTzDate } from './app_common.js';
import { delApiEdgeIdAlertResolved, delApiEdgeIdAlertStatus, getApiEdgeIdAlertStatus, getApiEdgeIdAlertStatusCount} from '../common/fetch_api/edge.js';
import { delApiAlertStatusFingerprint } from '../common/fetch_api/alert.js';

export const InvalidTokenModal = ({msg, show, handleClose}) => {

    useEffect(() => {
    }, []);

    const onClickConfirm = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
    }

    return (        
        <Modal
            show={show}
            keyboard={true}
            // backdrop="static"
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">NOTICE</h6>
            </Modal.Header>
            <Modal.Body>
                <div className='text-center'>
                    <p>{msg}</p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" className="btn-sm" onClick={onClickConfirm}>OK</Button>
            </Modal.Footer>
        </Modal>
    );
};

export const DecideWindow = ({result, show, handleClose, body, okButtonTxt}) => {

    useEffect(() => {
    }, []);

    const onClickConfirm = () => {
        result(true);
        closeModal();
    }

    const onClickCancel = () => {
        result(false);
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
    }

    return (        
        <Modal
            show={show}
            keyboard={true}
            onHide={() => {
                handleClose();
            }}
            // backdrop="static"
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
            <h6 className="modal-title">Confirmation</h6>
                <Button variant='close' className="btn-close-white" onClick={onClickCancel}></Button>
            </Modal.Header>
            <Modal.Body>
                {body}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickCancel}>Cancel</Button>
                <Button variant="success" className="btn-sm" onClick={onClickConfirm}>{okButtonTxt.length>1?okButtonTxt:'OK'}</Button>
            </Modal.Footer>
        </Modal>
    );
};

export const LicenseExpire = ({show, handleClose, body}) => {

    useEffect(() => {
    }, []);

    const onClickConfirm = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
    }

    return (        
        <Modal
            show={show}
            keyboard={true}
            onHide={() => {
                handleClose();
            }}
            // backdrop="static"
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
            <h6 className="modal-title">Warning</h6>
                <Button variant='close' className="btn-close-white" onClick={onClickConfirm}></Button>
            </Modal.Header>
            <Modal.Body>
                <div className='text-center text-warning'>
                    <h3>{body}</h3>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" className="btn-sm" onClick={onClickConfirm}>OK</Button>
            </Modal.Footer>
        </Modal>
    );
};

export const DateTimePicker = ({selectedDate, setSelectedDate}) => {
    /*
    <DatePicker className="form-control input-box text-center"
        selected={testStart}
        onChange={(date) => {onChangeTest(date);}}
        startDate={testStart}
        endDate={testEnd}
        selectsRange
        dateFormat="yyyy/MM/dd"
    />
    */

    return (
        <DatePicker className="form-control input-box date-picker text-center"
            selected={selectedDate}
            onChange={(date) => {setSelectedDate(date);}}
            timeIntervals={1}
            showTimeSelect
            dateFormat="yyyy/MM/dd hh:mm aa"
        />
    );
};

export const CalendarSeletor = ({result, calendarLabel, show, handleClose}) => {

    const [calValue, setCalValue] = useState(new Date());

    useEffect(() => {
    }, []);

    const onChangeCalendar = (e) => {
        // if( calendarLabel.includes('From'))
        // {
        //     e.setMinutes(0);
        //     e.setSeconds(0);
        // }
        // else if( calendarLabel.includes('To'))
        // {
        //     e.setMinutes(59);
        //     e.setSeconds(59);
        // }
        
        setCalValue(e);
    }

    const onClickConfirm = () => {
        result([true, dateToCalendar(calValue)]);
        closeModal();
    }

    const onClickCancel = () => {
        result([false, '']);
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
    }

    // const [testStart, setTestStart] = useState(new Date());
    // const [testEnd, setTestEnd] = useState(new Date());
    // const onChangeTest = (dates) => {
        
    //     const [start, end] = dates;

    //     if( start )
    //     {
    //         start.setHours(0);
    //         start.setMinutes(0);
    //         start.setSeconds(0);
    //     }
            
    //     if(end )
    //     {
    //         end.setHours(23);
    //         end.setMinutes(59);
    //         end.setSeconds(59);
    //     }

    //     setTestStart(start);
    //     setTestEnd(end);
    // }

    return (        
        <Modal
            show={show}
            keyboard={true}
            onHide={() => {
                handleClose();
            }}
            // backdrop="static"
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
            <h6 className="modal-title">{calendarLabel}</h6>
                <Button variant='close' className="btn-close-white" onClick={onClickCancel}></Button>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex justify-content-between">
                    <div>
                        <DateTimePicker selectedDate={calValue} setSelectedDate={onChangeCalendar}/>
                        {/* <input type="datetime-local" className="input-date" style={{width: '100%'}} value={calValue} onChange={onChangeCalendar}></input> */}
                    </div>
                    <div>
                        <Button variant="secondary" className="btn-sm ms-5 me-2" onClick={onClickCancel}>Cancel</Button>
                        <Button variant="success" className="btn-sm" onClick={onClickConfirm}>OK</Button>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
        </Modal>
    );
};

export const ChangePassword = ({username, show, handleClose, update }) => {

    const passwordCur = useRef('');
    const change1st = useRef('');
    const change2nd = useRef('');

    useEffect(() => {
    }, []);

    const onClickConfirm = () => {

        if(passwordCur.current.value !== change1st.current.value && (change1st.current.value === change2nd.current.value))
        {
            Promise.resolve( putApiUserPassword(username, passwordCur.current.value, change1st.current.value) )
            .then( done => {
                closeModal();
                update();
            });
        }
        else
        {
            showToast("You can't use the same password as the previous one", 'error');
        }
    }

    const onClickCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
    }

    return (        
        <Modal
            show={show}
            keyboard={true}
            onHide={closeModal}
            // backdrop="static"
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">Change Password</h6>
                <Button variant='close' className="btn-close-white" onClick={onClickCancel}></Button>
            </Modal.Header>
            <Modal.Body className='control-users-modal'>
                    <div className="d-flex">
                        <div className="col-4 label-box">Username</div>
                        <div className="col-8">
                            <input className="form-control input-box" type="text" value={username} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-4 label-box">Current Password</div>
                        <div className="col-8">
                            <input className="form-control input-box" type="password" ref={passwordCur}/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-4 label-box">New Password</div>
                        <div className="col-8">
                            <input className="form-control input-box" type="password" ref={change1st}/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-4 label-box">Confirm Password</div>
                        <div className="col-8">
                            <input className="form-control input-box" type="password" ref={change2nd}/>
                        </div>
                    </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickCancel}>Cancel</Button>
                <Button variant="success" className="btn-sm" onClick={onClickConfirm}>Save</Button>
            </Modal.Footer>
        </Modal>
    );
};

export const StatusAlertModal = ({edgeId, alertName, alertFilter, show, handleClose}) => {

    const PAGE_PER = 10;
    const CLEAR_TYPES = {
        RESOLVED: 'Resolved',
        ALERT: 'Alert',
        FINGERPRINT: 'Fingerprint'
    };

    const [update, setUpdate] = useState(false);
    const [statusAlertList, setStatusAlertList] = useState(null);
    const [selectedItems, setSelectedItems] = useState([]);

    const [edgeSelCount, setEdgeSelCount] = useState(1);
    const [curPageState, setCurPageState] = useState(1);
    const [modalDecide, setModalDecide] = useState(false);
    
    const curPageRef = useRef(0);
    const clearTarget = useRef('');

    const closeModalDecide = () => setModalDecide(false);
    const showModalDecide = (target) => {
        clearTarget.current = target;
        setModalDecide(true);
    };

    const resetPagination = () => {
        setEdgeSelCount(1);
        setCurPageState(1);
        curPageRef.current.value = 0;
    };

    const runUpdate = () => {
        setUpdate(!update);
    };

    const closeModal = () => {
        handleClose();
        show = false;
    };

    const onClickCancel = () => {
        closeModal();
    };

    const handleItemCheck = (isChecked, item, index) => {
        if (isChecked) {
            setSelectedItems(prev => [...prev, item]);
        } else {
            setSelectedItems(prev => prev.filter(selected => selected.fingerprint !== item.fingerprint));
        }
    };

    const handleClearAction = async (isConfirmed) => {
        if (!isConfirmed) return;

        try {
            switch (clearTarget.current) {
                case CLEAR_TYPES.RESOLVED:
                    await delApiEdgeIdAlertResolved(edgeId, alertFilter);
                    resetPagination();
                    break;
                case CLEAR_TYPES.ALERT:
                    await delApiEdgeIdAlertStatus(edgeId, alertFilter);
                    resetPagination();
                    break;
                case CLEAR_TYPES.FINGERPRINT:
                    // 체크된 항목들만 삭제
                    if (selectedItems.length > 0) {
                        // 체크된 항목들을 병렬로 삭제
                        await Promise.all(
                            selectedItems.map(item => 
                                delApiAlertStatusFingerprint(item.fingerprint)
                            )
                        );
                        setSelectedItems([]); // 선택된 항목 초기화
                    }
                    resetPagination();
                    break;
                default:
                    console.warn('Unknown clear target:', clearTarget.current);
                    return;
            }
            runUpdate();
        } catch (error) {
            console.error('Error clearing alert:', error);
        }
    };

    const renderStatusIcon = (status) => {
        switch (status) {
            case 'firing':
                return <BsFillRocketTakeoffFill className="text-info" />;
            case 'resolved':
                return <BsCheckCircleFill className="text-good" />;
            default:
                return null;
        }
    };

    const renderAlertItem = (item, index) => (
        <div className="card" key={index}>
            <div className="history-info">
                <input className="form-check-input" type="checkbox"
                    checked={item.checked || false}
                    onChange={e => {
                        if (typeof item.onCheck === 'function') {
                            item.onCheck(e.target.checked, item, index);
                        }
                    }}
                />
                <div className={`timeline-${item.severity} issue-date`}>
                    {utcToLocalDate(convertTzDate(item.date))}
                </div>
                <div>{renderStatusIcon(item.status)}</div>
                <div className={`text-${item.severity}`}>{item.labels.summary}</div>
                <div> | </div>
                <div className={`text-${item.severity}`}>{item.labels.message}</div>
            </div>
        </div>
    );

    useEffect(() => {
        console.log('alertFilter', alertFilter);
        curPageRef.current.value = curPageState;

        const fetchAlertData = async () => {
            try {
                const [count, data] = await Promise.all([
                    getApiEdgeIdAlertStatusCount(edgeId, alertFilter),
                    getApiEdgeIdAlertStatus(edgeId, PAGE_PER, curPageState, alertFilter, 'desc')
                ]);

                if (count && count.count > 0 && data) {
                    console.log('count', count);
                    setEdgeSelCount(count.count);
                    
                    console.log('data', data);
                    // 각 아이템에 체크 핸들러 추가하고 기존 선택 상태 유지
                    const itemsWithHandlers = data.map(item => {
                        const existingItem = selectedItems.find(selected => selected.fingerprint === item.fingerprint);
                        return {
                            ...item,
                            checked: existingItem ? true : false,
                            onCheck: handleItemCheck
                        };
                    });
                    setStatusAlertList(itemsWithHandlers.map(renderAlertItem));
                } else {
                    setStatusAlertList(null);
                }
            } catch (error) {
                console.error('Error fetching alert data:', error);
                setStatusAlertList(null);
            }
        };

        fetchAlertData();
    }, [curPageState, update, alertFilter, edgeId, selectedItems]);

    const ActionButtons = () => (
        <div className="d-flex justify-content-end my-2">
            <Button variant='primary' className="btn-sm me-1" 
                onClick={() => showModalDecide(CLEAR_TYPES.FINGERPRINT)}
                disabled={selectedItems.length === 0}
            >
                Remove Alert {selectedItems.length > 0 && `(${selectedItems.length})`}
            </Button>
            <Button variant='primary' className="btn-sm me-1" 
                onClick={() => showModalDecide(CLEAR_TYPES.RESOLVED)}
            >
                Clear Resolved
            </Button>
            <Button variant='primary' className="btn-sm" 
                onClick={() => showModalDecide(CLEAR_TYPES.ALERT)}
            >
                Clear Alert
            </Button>
        </div>
    );

    const DecideModalBody = () => {
        const isFingerprint = clearTarget.current === CLEAR_TYPES.FINGERPRINT;
        const selectedCount = selectedItems.length;
        
        return (
            <div className='text-center'>
                <p>
                    {isFingerprint 
                        ? `Would you like to remove ${selectedCount} selected alert(s)?`
                        : 'Would you like to clear this?'
                    }
                </p>
            </div>
        );
    };

    return (        
        <Modal
            className="status-alert-modal"
            show={show}
            keyboard={true}
            onHide={closeModal}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <h6 className="modal-title"><span className="text-info me-1">{alertName}</span> Alert</h6>
                <Button variant='close' className="btn-close-white" onClick={closeModal} />
            </Modal.Header>
            <Modal.Body>
                <ActionButtons />
                <div className="dashboard-offcanvas">
                    <div className="alert timeline">
                        <div className="outer">
                            {statusAlertList}
                        </div>
                    </div>
                </div>
                <PageNation
                    curPageState={curPageState}
                    setCurPageState={setCurPageState}
                    selCount={edgeSelCount}
                    pagePer={PAGE_PER}
                    ref={curPageRef}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickCancel}>Close</Button>
            </Modal.Footer>
            {modalDecide && (
                <DecideWindow 
                    result={handleClearAction} 
                    show={modalDecide} 
                    handleClose={closeModalDecide} 
                    body={<DecideModalBody />} 
                    okButtonTxt={'Clear'} 
                />
            )}
        </Modal>
    );
};